import * as Yup from 'yup'

export const ValidationSchema = Yup.object().shape({
  name: Yup.string().required("Campo requerido"),
  slug: Yup.string().required("Campo requerido"),
  active: Yup.boolean().required("Campo requerido"),
})